<nav class="navbar container-fluid p-0 w-100 g-0">
  <div class="d-flex h-100 row w-100 align-items-center flex-nowrap">
    <div class="d-flex align-items-center col py-2">
      <ng-container [ngTemplateOutlet]="homeIcons"></ng-container>
      <div class="d-flex justify-content-around align-items-center flex-fill miw-0">
        <div class="d-flex w-100 w-sm-75 w-xxl-50 miw-0">
          <div class="d-flex me-3 flex-fill miw-0">
            @if (selectedScope) {
              <ng-container
                [ngTemplateOutlet]="scopeSelector"
                class="me-3 ms-1"
              ></ng-container>
            }
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center d-md-none">
        <ng-container [ngTemplateOutlet]="mobileMenuToggle"></ng-container>
      </div>
    </div>
    <div class="d-none d-md-flex align-items-center col-md-4 col-lg-3">
      <div class="d-flex justify-content-around align-items-center flex-fill">
        @if (selectedScope) {
          <ng-container
            [ngTemplateOutlet]="navItemsApps"
          ></ng-container>
        }
      </div>
      <div class="d-flex align-items-center">
        <ng-container [ngTemplateOutlet]="userPreferencesMenu"></ng-container>
      </div>
    </div>
  </div>
</nav>

<ng-template #mobileMenuToggle>
  <button
    class="btn btn-icon-light"
    (click)="onMobileSidenavToggle.emit()"
    >
    <svg-icon
      name="menu"
      class="fill-current"
      style="width: 1.5rem; height: 1.5rem;"
    ></svg-icon>
  </button>
</ng-template>

<ng-template #homeIcons>
  <a
    class="align-items-center d-flex"
    [ngStyle]="{'height.rem':2.6}"
    routerLink="/"
    >
    <svg-icon
      class="ms-2 d-none d-sm-flex align-items-center"
      [svgStyle]="{'height.rem':1.2}"
      name="recap-logo"
    ></svg-icon>
    @if (clientLogo$ | async; as clientLogo) {
      <div
        class="d-none d-lg-flex align-items-center border-start border-end border-light px-3 mx-2"
        [ngStyle]="{'height.rem':1.2}"
        >
        <img
          height="100%"
          width="auto"
          [src]="clientLogo.url"
          >
      </div>
    }
  </a>
</ng-template>

<ng-template #clock>
  @if (currentTime$ | async; as currentTime) {
    <ng-container
      class="d-flex align-items-center"
      >
      <span class="mx-1 d-flex align-items-center text-nowrap">{{ currentTime }}</span>
    </ng-container>
  }
</ng-template>

<ng-template #scopeSelector>
  <div class="d-flex align-items-center flex-fill miw-0">
    <div
      class="d-flex flex-fill align-items-center justify-content-between cursor-pointer miw-0"
      ngbDropdown
      #scopeDropdown="ngbDropdown"
      (openChange)="onScopeDropdownToggle($event)"
      display="dynamic"
      >
      <div
        class="w-100 h-100 d-flex align-items-center justify-content-between"
        ngbDropdownAnchor
        >
        <button
          class="btn btn-icon-light p-0 m-0 d-flex align-items-center"
          (click)="previousScope()"
          >
          <svg-icon
            class="m-1 d-flex align-items-center fill-current text-secondary"
            name="arrow"
            style="transform: scaleX(-1)"
          ></svg-icon>
        </button>
        <div
          ngbDropdownToggle
          class="d-flex flex-fill justify-content-between align-items-center miw-0"
          >
          <div class="flex-fill ps-2 font-weight-bold text-truncate flex-fill">
            {{currentScopeDisplayName$ | async}}
          </div>
          <ng-container [ngTemplateOutlet]="clock"></ng-container>
          <div class="p-1 m-0 d-flex align-items-center">
            <svg-icon
              class="d-flex align-items-center fill-current"
              [ngClass]="scopeDropdown.isOpen() ? 'text-info' : 'text-secondary'"
              name="caret-down"
            ></svg-icon>
          </div>
        </div>
        <button
          class="btn btn-icon-light p-0 m-0 d-flex align-items-center d-flex align-items-center fill-current text-secondary"
          (click)="nextScope()"
          >
          <svg-icon
            class="m-1 d-flex align-items-center"
            name="arrow"
          ></svg-icon>
        </button>
      </div>
      <div
        ngbDropdownMenu
        class="shadow-sm border-0 p-0 mt-2 w-100"
        >
        <ng-container [ngTemplateOutlet]="scopeDropdownContent"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #navItemsApps>
  <a
    class="btn btn-icon-charts p-0 nav-items d-flex align-items-center justify-content-center rounded-circle"
    [class.bg-charts]="(hoveredLink$ | async) === 'charts'"
    (mouseenter)="hoverNavIcon('charts')"
    (mouseleave)="hoverNavIcon(null)"
    [ngStyle]="{'height.rem':3.25,'width.rem':3.25}"
    [routerLinkActiveOptions]="{ queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored', paths: 'subset'}"
    [routerLink]="['/', selectedScope.id, 'charts']"
    routerLinkActive="active"
    tooltipClass="custom-tooltip no-arrow mt-2"
    i18n-ngbTooltip
    ngbTooltip="Charts"
    >
    <svg-icon
      class="d-flex h-50 w-50 align-items-center justify-content-center"
      name="chart"
    ></svg-icon>
  </a>
  @if ((watchesFeatureFlag$|async); as watchesFeatureFlag) {
    <a
      class="btn btn-icon-watches p-0 nav-items d-flex align-items-center justify-content-center rounded-circle"
      [class.bg-watches]="(hoveredLink$ | async) === 'watches'"
      [class.disabled]="!watchesFeatureFlag.isEnabled"
      (mouseenter)="hoverNavIcon('watches')"
      (mouseleave)="hoverNavIcon(null)"
      [ngStyle]="{'height.rem':3.25,'width.rem':3.25,'pointer-events':'auto'}"
      [routerLink]="watchesFeatureFlag.isEnabled ? ['/', selectedScope.id, 'watch-procedures'] : null"
      [routerLinkActiveOptions]="{ queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored', paths: 'subset'}"
      routerLinkActive="active"
      tooltipClass="custom-tooltip no-arrow mt-2"
      i18n-ngbTooltip
      [ngbTooltip]="watchesTooltip"
      >
      <ng-template #watchesTooltip>
        <ng-container i18n>Watches</ng-container>
        @if (!watchesFeatureFlag.isEnabled) {
          (<ng-container i18n>disabled for your organization</ng-container>)
        }
      </ng-template>
      <svg-icon
        class="d-flex fill-current align-items-center justify-content-center"
        name="watch"
      ></svg-icon>
    </a>
  }
  @if ((reportsFeatureFlag$|async); as reportsFeatureFlag) {
    <a
      class="btn btn-icon-reports p-0 nav-items d-flex align-items-center justify-content-center rounded-circle"
      [class.bg-reports]="(hoveredLink$ | async) === 'reports'"
      [class.disabled]="!reportsFeatureFlag.isEnabled"
      (mouseenter)="hoverNavIcon('reports')"
      (mouseleave)="hoverNavIcon(null)"
      [ngStyle]="{'height.rem':3.25,'width.rem':3.25,'pointer-events':'auto'}"
      [routerLink]="reportsFeatureFlag.isEnabled ? ['/', selectedScope.id, 'reporting-processes'] : null"
      [routerLinkActiveOptions]="{ queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored', paths: 'subset'}"
      routerLinkActive="active"
      tooltipClass="custom-tooltip no-arrow mt-2"
      [ngbTooltip]="reportsTooltip"
      >
      <ng-template #reportsTooltip>
        <ng-container i18n>Reports</ng-container>
        @if (!reportsFeatureFlag.isEnabled) {
          (<ng-container i18n>disabled for your organization</ng-container>)
        }
      </ng-template>
      <svg-icon
        class="d-flex h-50 w-50 align-items-center justify-content-center"
        name="report"
      ></svg-icon>
    </a>
  }
  @if ((readingsFeatureFlag$|async); as readingsFeatureFlag) {
    <a
      class="btn btn-icon-readings p-0 nav-items d-flex align-items-center justify-content-center rounded-circle"
      [class.bg-readings]="(hoveredLink$ | async) === 'readings'"
      [class.disabled]="!readingsFeatureFlag.isEnabled"
      (mouseenter)="hoverNavIcon('readings')"
      (mouseleave)="hoverNavIcon(null)"
      [ngStyle]="{'height.rem':3.25,'width.rem':3.25,'pointer-events':'auto'}"
      [routerLink]="readingsFeatureFlag.isEnabled ? ['/', selectedScope.id, 'reading-forms'] : null"
      [routerLinkActiveOptions]="{ queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored', paths: 'subset'}"
      routerLinkActive="active"
      tooltipClass="custom-tooltip no-arrow mt-2"
      [ngbTooltip]="readingsTooltip"
      >
      <ng-template #readingsTooltip>
        <ng-container i18n>Manual readings</ng-container>
        @if (!readingsFeatureFlag.isEnabled) {
          (<ng-container i18n>disabled for your organization</ng-container>)
        }
      </ng-template>
      <svg-icon
        class="d-flex h-50 w-50 align-items-center justify-content-center"
        name="pen"
      ></svg-icon>
    </a>
  }
  @if ((wasteFeatureFlag$|async); as wasteFeatureFlag) {
    @if (wasteFeatureFlag.isEnabled) {
      <a
        class="btn btn-icon-waste p-0 nav-items d-flex align-items-center justify-content-center rounded-circle"
        [class.bg-waste]="(hoveredLink$ | async) === 'waste'"
        (mouseenter)="hoverNavIcon('waste')"
        (mouseleave)="hoverNavIcon(null)"
        [ngStyle]="{'height.rem':3.25,'width.rem':3.25}"
        [routerLink]="['/', selectedScope.id, 'waste']"
        [routerLinkActiveOptions]="{ queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored', paths: 'subset'}"
        routerLinkActive="active"
        tooltipClass="custom-tooltip no-arrow mt-2"
        i18n-ngbTooltip
        ngbTooltip="Waste"
        >
        <svg-icon
          class="d-flex h-50 w-50 align-items-center justify-content-center"
          name="waste"
        ></svg-icon>
      </a>
    }
  }

</ng-template>

<ng-template #userPreferencesMenu>
  <div
    class="user-menu d-flex align-items-center"
    ngbDropdown
    autoClose="outside"
    display="dynamic"
    placement="bottom-left bottom bottom-right"
    >
    <button
      class="btn btn-icon-light p-0 nav-item d-flex align-items-center justify-content-center rounded-pill"
      ngbDropdownToggle
      [ngStyle]="{'height.rem':1.75,'width.rem':2.75}"
      >
      <!-- <fa-icon [icon]="['far', 'user-circle']"></fa-icon> -->
      <svg-icon
        class="d-flex h-100 w-75 align-items-center justify-content-center"
        name="ellipsis"
        svgClass="h-100"
        >
      </svg-icon>
      <svg-icon
        class="ms-1 d-flex align-items-center"
        name="caret-down"
      ></svg-icon>
    </button>
    <ul
      ngbDropdownMenu
      class="shadow-sm border-0 p-0"
      >
      @if (showProfileLink$ | async) {
        <li>
          <a
            ngbDropdownItem
            class="d-flex align-items-center"
            [href]="hrefToProfile$ | async"
            >
            <svg-icon
              class="d-flex align-items-center justify-content-center me-2"
              style="height: 1rem; width: 1rem;"
              name="account"
              svgClass="h-100 w-100"
              >
            </svg-icon>
            <span i18n>My account</span>
          </a>
        </li>
      }
      @if (availableLanguages$ | async; as availableLanguages) {
        @if (currentLocale$ | async; as currentLocale) {
          @if (availableLanguages.length > 1) {
            <li
              ngbDropdown
              display="dynamic"
              >
              <button
                ngbDropdownItem
                ngbDropdownToggle
                type="button"
                class="btn d-flex align-items-center w-100 border-0"
                >
                <svg-icon
                  class="d-flex align-items-center justify-content-center me-2"
                  style="height: 1rem; width: 1rem;"
                  name="languages"
                  svgClass="h-100 w-100"
                ></svg-icon>
                {{ currentLocale | uppercase }}
                <svg-icon
                  name="caret-down"
                  class="ms-2"
                ></svg-icon>
              </button>
              <ul
                ngbDropdownMenu
                class="shadow-sm border-0 p-0"
                >
                @for (lang of availableLanguages; track lang) {
                  <li>
                    <a
                      ngbDropdownItem
                      (click)="selectLanguage(lang)"
                      [ngClass]="{'fw-bold text-primary': currentLocale === lang}"
                    >{{lang | uppercase}}</a>
                  </li>
                }
              </ul>
            </li>
          }
        }
      }
      @if (exports$ | async; as exports) {
        @if (exports.length > 0) {
          <li
            ngbDropdown
            display="dynamic"
            >
            <button
              ngbDropdownItem
              ngbDropdownToggle
              type="button"
              class="btn d-flex align-items-center w-100 border-0"
              >
              <svg-icon
                class="d-flex align-items-center justify-content-center me-2"
                style="height: 1rem; width: 1rem;"
                name="export"
                svgClass="h-100 w-100"
              ></svg-icon>
              <span i18n>Exports</span>
              <svg-icon
                name="caret-down"
                class="ms-2"
              ></svg-icon>
            </button>
            <ul
              ngbDropdownMenu
              class="shadow-sm border-0 p-0"
              >
              @for (export of exports; track export) {
                <li>
                  <a
                    ngbDropdownItem
                    href="{{export.href}}"
                  >{{export.name}}</a>
                </li>
              }
            </ul>
          </li>
        }
      }
      <li>
        <a
          ngbDropdownItem
          class="d-flex align-items-center"
          href="/captain"
          target="_blank"
          >
          <svg-icon
            class="d-flex align-items-center justify-content-center me-2"
            style="height: 1rem; width: 1rem;"
            name="externalLink"
            svgClass="h-100 w-100"
          ></svg-icon>
          <span>Captain</span>
        </a>
      </li>
      @if (helpUrl$ | async; as helpUrl) {
        <li>
          <a
            ngbDropdownItem
            class="d-flex align-items-center"
            [href]="helpUrl"
            target="_blank"
            >
            <svg-icon
              class="d-flex align-items-center justify-content-center me-2"
              style="height: 1rem; width: 1rem;"
              name="help"
              svgClass="h-100 w-100"
              >
            </svg-icon>
            <span i18n>Help</span>
          </a>
        </li>
      }
      <li>
        <a
          ngbDropdownItem
          class="dropdown-item d-flex align-items-center"
          href="#"
          (click)="logout()"
          >
          <svg-icon
            class="d-flex align-items-center justify-content-center me-2"
            style="height: 1rem; width: 1rem;"
            name="logout"
            svgClass="h-100 w-100"
            >
          </svg-icon>
          <span i18n>Log out</span>
        </a>
      </li>
      <li>
        <div
          ngbDropdownItem
          class="disabled border-top"
          >
          {{'RECAP v'+version}}
        </div>
      </li>
    </ul>
  </div>
</ng-template>

<ng-template #scopeDropdownContent>
  @if ((scopes$ | async); as scopes) {
    <div
      class="list-group"
      >
      <a
        class="d-flex align-items-center list-group-item border-0 bg-light-hover border-light cursor-pointer border-start-0 border-end-0 border-bottom-0 text-decoration-none"
        routerLink="/"
        >
        <svg-icon
          class="me-2 fill-current"
          name="map"
          style="width: 1.3rem;height: 1.3rem;"
        ></svg-icon>
        <div
          style="font-weight: 500"
          i18n
        >Return to map</div>
      </a>
      <div
        class="d-flex flex-column h-100"
        style="max-height: 40vh;"
        >
        <form
          class="position-sticky top-0 border-top border-bottom border-light"
          (submit)="submit()"
          >
          <div class="p-2 d-flex flex-column justify-content-center align-items-center scope-search-wrapper bg-background-secondary">
            <input
              id="searchScopeInputHeader"
              type="text"
              class="form-control flex-grow-1 border-0 rounded"
              placeholder="Search"
              i18n-placeholder
              autoSelect
              (input)="updateFilter(input.value)"
              [value]="scopeFilterValue"
              #input
              />
            <svg-icon
              class="text-info position-absolute end-0 me-3 fill-current"
              name="search"
            ></svg-icon>
          </div>
        </form>
        @if (scopesError) {
          <div
            class="alert alert-danger rounded-0 d-flex align-items-center"
            >
            <fa-icon
              icon="exclamation-triangle"
              class="me-3"
            ></fa-icon>
            <div
              class="flex-grow-1"
              i18n
            >Cannot load list of scopes</div>
            <button
              class="btn d-flex align-items-center justify-content-center btn-light btn-sm ms-3"
              (click)="this.ngOnInit()"
              i18n
            >Retry</button>
          </div>
        }
        @if (!error) {
          <div
            class="list-group d-flex flex-column overflow-auto"
            id="scope-list-container"
            >
            @for (scope of scopes | pureFilter: scopeFilterFn | pureSort: scopeSortFn; track scope) {
              <a
                [id]="'link-' + scope.id"
                class="w-100 list-group-item border-0 rounded-0 py-2 pe-2 ps-3 pointer bg-light-hover"
                [ngClass]="{'text-primary fw-bold': scope.id === selectedScope.id}"
                (click)="switchScope(scope)"
              >{{ scope.displayName }}</a>
            }
          </div>
        }
      </div>
    </div>
  }
</ng-template>
